export default function() {

  /**
  * Query the existence of the target element. If the element does not
  * exist, stop executing the function.
  */

  let layoutGroups = document.querySelectorAll('[data-layout-group]')

  if (!layoutGroups) { return; }

  layoutGroups.forEach(el => {
    let controls = el.querySelectorAll('[data-layout-toggle]')
    let layouts = el.querySelectorAll('.o-toggle-layout');

    controls.forEach(control => {

      control.addEventListener('click', function(e) {
        controls.forEach(control => {
          control.removeAttribute('aria-selected');
          control.parentNode.classList.remove('active');
        });

        control.setAttribute('aria-selected', true);
        control.parentNode.classList.add('active');

        let controlId = control.dataset.layoutToggle;

        layouts.forEach(layout => {
          layout.className = '';
          layout.classList.add('o-toggle-layout', 'o-toggle-layout--' + controlId);
        });
      })
    });
  });
}
